import { render, staticRenderFns } from "./UsersPrivilegeTreasuries.vue?vue&type=template&id=22c14098&scoped=true&"
import script from "./UsersPrivilegeTreasuries.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeTreasuries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c14098",
  null
  
)

export default component.exports